import { render, staticRenderFns } from "./ProductWidget.vue?vue&type=template&id=4e42bd17&"
import script from "./ProductWidget.vue?vue&type=script&lang=js&"
export * from "./ProductWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports